import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";

import { getAssetUrl } from "../../utils/url";
import "../class-complete-seal/class-complete-seal";
import { getCertificateResponsiveProperties } from "./utils";

import styles from "./class-complete-certificate.css";

const DEFAULT_HEADING = "Certificate of Completion";
const DEFAULT_PRE_TITLE = "This certificate is awarded to";
const DEFAULT_TEACHER_LABEL = "Teacher";

@customElement("bp-class-complete-certificate")
export class ClassCompleteCertificate extends LitElement {
  static styles = styles;

  @property({ attribute: "artwork-src" })
  artworkSrc = "";

  @property({ attribute: "class-title" })
  classTitle = "";

  @property()
  date = "";

  @property()
  heading = DEFAULT_HEADING;

  @property({ attribute: "pre-title" })
  preTitle = DEFAULT_PRE_TITLE;

  @property({ attribute: "student-name" })
  studentName = "";

  @property({ attribute: "teacher-name" })
  teacherName = "";

  @property({ attribute: "teacher-signature-src" })
  teacherSignatureSrc = "";

  @property({ attribute: "teacher-label" })
  teacherLabel = DEFAULT_TEACHER_LABEL;

  render() {
    return html`
      <div
        class="certificate"
        style=${styleMap(getCertificateResponsiveProperties())}
      >
        <div class="body">
          <header>
            <div class="seal">
              <bp-class-complete-seal
                artwork-src=${this.artworkSrc}
              ></bp-class-complete-seal>
            </div>
            <p class="heading">${this.heading}</p>
          </header>

          <main>
            <p class="pre-title">${this.preTitle}</p>
            <p class="student-name">${this.studentName}</p>
            <p class="post-title">
              For the completion of
              <strong>${this.classTitle}</strong> on
              <strong>${this.date}</strong>
            </p>
          </main>

          <footer>
            <div class="signature-box">
              <div class="signature">
                <img src=${this.teacherSignatureSrc} alt=${this.teacherName} />
              </div>
              <div class="signature-label">${this.teacherLabel}</div>
            </div>

            <div class="logo">
              <img src=${getAssetUrl("/bibleproject.svg")} alt="BibleProject" />
            </div>
          </footer>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-class-complete-certificate": ClassCompleteCertificate;
  }
}
